import { useState, useEffect } from "react";

export const MAX_MOBILE_SCREEN = 744;
export const MAX_TABLET_SCREEN = 1024;
export enum Devices {
  DESKTOP = "desktop",
  TABLET = "tablet",
  MOBILE = "mobile",
}
export type DeviceTypes = `${Devices}`;

export function debounce(func, milliseconds) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(this, args);
    }, milliseconds);
  };
}

/**
 *
 * @param debounceTime - In Milliseconds. Amount of time that the hook does not register another window resize.
 * @returns
 */
export function useViewport(debounceTime: number = 0) {
  const [width, setWidth] = useState(undefined);
  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setWidth(window.innerWidth);
    }, debounceTime);

    window.addEventListener("resize", debouncedHandleResize);
    debouncedHandleResize();

    return () => window.removeEventListener("resize", debouncedHandleResize);
  }, [debounceTime]);
  if (width < MAX_MOBILE_SCREEN) return Devices.MOBILE;
  if (width >= MAX_MOBILE_SCREEN && width < MAX_TABLET_SCREEN)
    return Devices.TABLET;
  if (width >= MAX_TABLET_SCREEN) return Devices.DESKTOP;
  return Devices.MOBILE;
}
